module.exports = __webpack_public_path__ + "static/media/avatar.5d9e9dff.svg";